<template>
  <div>
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>个人信息</el-breadcrumb-item>
        <el-breadcrumb-item>个人信息完善</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card>
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="name">
          <el-input type="text" v-model="ruleForm.name" placeholder="请输入您的姓名" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="学号" prop="studentID">
          <el-input type="text" :disabled="(studentID2==''||studentID2==null)?false:true" placeholder="请谨慎填写" maxlength="9" v-model="ruleForm.studentID" ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobiles">
          <el-input type="text" placeholder="请输入手机号" maxlength="11" :disabled="(mobList==null||mobList=='')?false:true" v-model="ruleForm.mobiles" ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input  maxlength="20" placeholder="请输入邮箱" v-model="ruleForm.email" ></el-input>
        </el-form-item>

        <el-form-item label="宿舍号" prop="roomId">
          <el-input type="number" placeholder="请输入宿舍号" maxlength="8"  v-model="ruleForm.roomId" ></el-input>
        </el-form-item>

        <el-form-item label="请选择导师" prop="tutorid">
  <el-select v-model="ruleForm.tutorid" placeholder="请选择导师">
      <el-option  :label="teacher.name" :value="teacher.userid" v-for="(teacher,index) in teacherList" :key="index"></el-option>
    </el-select>
</el-form-item>


<el-form-item label="请选择班级" prop="tutorid">
  <el-select v-model="ruleForm.classId" placeholder="请选择班级">
      <el-option  :label="classGre.className" :value="classGre.classId" v-for="(classGre,index) in classList" :key="index"></el-option>
    </el-select>
</el-form-item>
   

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>




  </div>
</template>

<script>
  import { checkMobiles,checkEmail} from '@/components/work/until/vaildate.js'
export default {
  created() {
    this.getUserByID()
  },
  data() {
    var studentID = (rule, value, callback) => {
      let reg = /^[0-9]{9}$/;
      if (!reg.test(value)) {
        callback(new Error("由九位数字组成"))
      } else {
        callback();
      }


    }


    return {
      teacherList:[],
      classList:[],
      mobList:'',
      studentID2:'',
      ruleForm: {
        mobiles: '',
        name: '',
        studentID: '',
        userid: '',
        tutorid:'',
        email:'',
        classId:'',
        roomId:''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        studentID: [
          { required: true, message: '请输入学号', trigger: 'blur' },
          { validator: studentID }
        ],
        mobiles:[
        { required: true, message: '请输入手机号', trigger: 'blur' },
          {validator:checkMobiles}
        ],
        email:[
        { required: true, message: '请输入邮箱', trigger: 'blur' },
          {validator:checkEmail}
        ],
        roomId:[
        { required: true, message: '请输入宿舍号', trigger: 'blur' },
        { min: 1, max: 8, message: '长度在 3 到 5 个数字', trigger: 'blur' }
        ],
      }

    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let config = { headers: { "Content-Type": "application/json" } };
          const formData = new FormData()
          formData.append('userid', JSON.parse(localStorage.getItem('user')).userid)
          formData.append("name", this.ruleForm.name)
          formData.append("studentID", this.ruleForm.studentID)
          formData.append("mobiles", this.ruleForm.mobiles)
          formData.append("tutorid", this.ruleForm.tutorid)
          formData.append("email", this.ruleForm.email)
          formData.append("classId", this.ruleForm.classId)
          formData.append("roomId", this.ruleForm.roomId)
          this.axios.post("/user/updateUserInfo", formData, config)
            .then(resp => {
              if (resp.data.status == 1) {
                localStorage.setItem('user', JSON.stringify(resp.data.result));
                this.$message.success("完善成功")
                this.getUserByID()
              } else {
                this.$message.error(resp.data.message)
              }
            }).catch((err) => {
              alert("出错了")
            })
        }
      })

    },
    getUserByID() {
      this.axios.post("/user/getUserByID", "userid=" + JSON.parse(localStorage.getItem('user')).userid)
        .then(resp => {
          if (resp.data.status == 1) {
            console.log(resp.data.result)
           this.mobList=resp.data.result.mobiles
           this.studentID2=resp.data.result.studentID
            this.ruleForm.name = resp.data.result.name
            this.ruleForm.studentID = resp.data.result.studentID
            this.ruleForm.mobiles = resp.data.result.mobiles
            this.ruleForm.tutorid = resp.data.result.tutorid
            this.ruleForm.classId = resp.data.result.classId
            this.ruleForm.roomId = resp.data.result.roomId
            if(resp.data.result.email!=''){
              this.ruleForm.email = resp.data.result.email
            }


          }
        })
        this.axios.post("/user/getUser",'type=5')
             .then(res=>{
              if(res.data.status==1){
               this.teacherList=res.data.result
              }
             })

             this.axios.post("/classGrade/getClassGrade")
             .then(res=>{
              if(res.data.status==1){
                console.log(res.data.result)
                this.classList=res.data.result
               
              }
             })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.mobiles = this.mobList
      this.ruleForm.studentID = this.studentID2

    }

  }
}
</script>

<style>
.el-card {
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/work/student/EVPI.vue